import React, { useEffect, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import FormReactSelectResidenceInput from '../formInputsV2/FormReactSelectResidenceInput';
import { FormInputText } from '../formInputsV2/FormInputText';
import { FormInputAddress } from '../formInputsV2/FormInputAddress';

function FormInputAddressHouseComplete({
  municipalities,
  formData,
  isValid,
  errors,
  register,
  updateFormData,
  addressId,
  setShow = null,
  showManualAdress = false,
}) {
  const communesRef = useRef();

  communesRef.current = municipalities;

  useEffect(() => {
    if (['auto', 'autocarro', 'moto', 'ancillari_auto'].includes(formData.product)) {
      if (formData.current_address !== '' && formData.current_postal_code && !isValid('current_postal_code') && setShow !== null) {
        setShow(true);
      }
    } else if (formData.current_postal_code && !isValid('current_postal_code') && setShow !== null) {
      setShow(true);
    }
  }, [formData.current_postal_code]);

  useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: ['places'],
    });

    loader.load().then((google) => {
      const autocomplete = new google.maps.places.Autocomplete(
        document.getElementById(addressId),
        {
          fields: ['formatted_address', 'name', 'address_components'],
          types: ['address'],
          componentRestrictions: { country: 'it' },
        },
      );

      const actionTakeOnAutocomplete = async () => {
        const place = autocomplete.getPlace();

        const clearInputs = {
          current_address: '',
          house_commune_code: '',
          house_province_code: '',
          current_postal_code: '',
        };

        if (place === undefined || place.address_components === undefined) {
          updateFormData(clearInputs);
          return;
        }

        const address = place.address_components.find(
          (c) => c.types.join(',') === 'route',
        ).long_name;
        const commune = communesRef.current.find(
          (m) => m.name
            === place.address_components.find(
              (c) => c.types.join(',') === 'administrative_area_level_3,political',
            )?.long_name,
        );

        if (commune === undefined) {
          updateFormData(clearInputs);
          return;
        }

        const residence_commune_code = commune.cadastral_code;
        const residence_province_code = commune.communal_territory.car_plate_symbol;
        const postal_code = place.address_components.find(
          (c) => c.types.join(',') === 'postal_code',
        )?.long_name ?? commune.postal_code;

        updateFormData({
          current_address: address,
          house_commune_code: residence_commune_code,
          house_province_code: residence_province_code,
          current_postal_code: postal_code,
        });
      };

      autocomplete.addListener('place_changed', actionTakeOnAutocomplete);
      document.getElementById(addressId).onblur = actionTakeOnAutocomplete;
    });

    return () => {
      if (loader) {
        loader.reset();
        delete window.google;
        Loader.instance = undefined;
      }
    };
  }, []);

  return (
    <>
      <FormInputAddress
        valueAddress={formData.current_address}
        valueHouse={formData.current_house_number}
        label="Cerca indirizzo abitazione"
        subText="Se ci sono più strade con lo stesso nome, scrivi nell'indirizzo il comune"
        onAddressChange={(value) => updateFormData({ current_address: value })}
        onHouseNumberChange={(value) => updateFormData({ current_house_number: value })}
        addressError={errors.current_address?.message}
        houseNumberError={errors.current_house_number?.message}
        validAddress={isValid('current_address')}
        validHouseNumber={isValid('current_house_number')}
        addressId={addressId}
      />

      {formData.house_commune_code !== ''
        && formData.house_province_code !== ''
        && formData.current_postal_code !== ''
        && (
          <div>
            <p className="m-0 fw-bold" style={{ fontSize: '15px', marginTop: '-10px' }}>
              Comune:
              {' '}
              {municipalities.filter((opt) => opt.cadastral_code === formData.house_commune_code).map((o) => ({ value: o.cadastral_code, label: `${o.name} (${o.communal_territory.car_plate_symbol})` }))[0]?.label}

            </p>
          </div>
        )}

      <div className="text-dark">
        <p
          className="mt-1 mb-3 fw-bold"
          style={{ fontSize: '13px', marginTop: '-10px' }}
        >
          oppure
          {' '}
          <button
            className="fw-bold text-decoration-underline border-0 text-success bg-transparent"
            onClick={() => setShow(true)}
          >
            inserisci l'indirizzo manualmente
          </button>
        </p>
      </div>
      {showManualAdress !== false && formData.house_commune_code !== ''
        && formData.house_province_code !== ''
        && formData.current_postal_code !== '' && (
          <FormReactSelectResidenceInput
            label="Residenza (Dall'indirizzo)"
            options={municipalities}
            values={{
              residence_commune_code: formData.house_commune_code,
              residence_province_code: formData.house_province_code,
              postal_code: formData.current_postal_code,
            }}
            disabled
            valid={isValid('house_commune_code')}
          >
            <FormInputText
              label="Codice Postale"
              registration={register('current_postal_code')}
              error={errors.current_postal_code?.message}
              valid={isValid('current_postal_code')}
            />
          </FormReactSelectResidenceInput>
      )}
    </>
  );
}

export default FormInputAddressHouseComplete;
